export default {
  getGoogleLoginFeatureFlag: (state) => state?.features?.googleLogin,
}